import React, { useState } from "react";
const Newsletter: React.FC = () => {
    const [newsLetterIsSent, setNewsLetterIsSent] = useState(false);
    const sendData = async () => {
        
        const email = (document.getElementById("emailadr") as HTMLInputElement).value.trim();
        
        try {
            const response = await fetch("/api/subscription/add", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    Email: email,
                    Newsletter: "74485",
                })
            });
            if (response.ok) {
                setNewsLetterIsSent(true);
            }
        } catch (e) {
            alert('Det oppstod en feil under sending av data. Vennligst prøv igjen senere');
            console.log(e);
        }
    }
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        sendData();
    };
    return (
        <>
            {newsLetterIsSent ? (
                <div className="text-xl font-normal h-full flex items-center">
                    Takk for at du meldte deg på vårt nyhetsbrev!
                </div>
            ) : (
                <form
                    id="newsletter"
                    className="flex flex-col gap-2 tablet:flex-row tablet:justify-end"
                    onSubmit={handleSubmit}
                >
                    <div className="grid grid-cols-1 w-full">
                        <input
                            id="emailadr"
                            type="email"
                            className="w-full col-start-1 row-start-1 px-6 py-3 pl-10 rounded-xl border-2 border-brown-primary placeholder-black-subtile text-lg active:outline-none focus:outline-red-secondary focus:outline-2"
                            placeholder="E-postadresse"
                            required
                            pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                            onInvalid={(e) =>
                                (e.target as HTMLInputElement).setCustomValidity(
                                    "Skriv inn en gyldig e-postadresse."
                                )
                            }
                            onInput={(e) =>
                                (e.target as HTMLInputElement).setCustomValidity("")
                            }
                        />
                        <div
                            className="icon-mail pointer-events-none col-start-1 row-start-1 self-center ml-3"
                            aria-hidden="true"
                        ></div>
                    </div>
                    <button
                        type="submit"
                        className="flex items-center btn-primary justify-center transition-colors duration-300 tablet:min-w-fit hover:bg-brown-50 focus:outline-red-secondary focus:outline-2"
                    >
                        Meld på
                        <div className="icon-arrow-right" aria-hidden="true"></div>
                    </button>
                </form>
            )}
        </>
    );
};

export default Newsletter;